export const CAMPAIGN_STATUSES = [
    { value: 'None', label: 'Pending', badgeColor: 'gray.5' }, // neutral / undefined
    { value: 'Queued', label: 'Queued', badgeColor: 'yellow.4' }, // waiting
    { value: 'Provisioning', label: 'Provisioning', badgeColor: 'blue.5' }, // setting‑up resources
    { value: 'Initializing', label: 'Initializing', badgeColor: 'indigo.5' }, // warm‑up
    { value: 'Running', label: 'Running', badgeColor: 'teal.6' }, // active & healthy
    { value: 'Complete', label: 'Complete', badgeColor: 'green.4' }, // finished successfully
    { value: 'Paused', label: 'Paused', badgeColor: 'orange.4' }, // on hold
    { value: 'Stopping', label: 'Stopping', badgeColor: 'pink.5' }, // currently stopping
    { value: 'Stopped', label: 'Stopped', badgeColor: 'red.5' }, // halted by user/system
    { value: 'Scheduled', label: 'Scheduled', badgeColor: 'cyan.4' }, // future launch
    { value: 'Faulted', label: 'Faulted', badgeColor: 'red.5' }, // errored / failed
];

export const CAMPAIGN_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray' },
    { value: 'Sms', label: 'Sms', badgeColor: 'blue.5' },
    { value: 'Rvm', label: 'Rvm', badgeColor: 'teal.6' },
    { value: 'Email', label: 'Email', badgeColor: 'grape.4' },
];

export const CAMPAIGN_MESSAGE_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray' },
    { value: 'Sms', label: 'Sms', badgeColor: 'blue.5' },
    { value: 'Mms', label: 'Mms', badgeColor: 'blue.8' },
    { value: 'Rvm', label: 'Rvm', badgeColor: 'teal.6' },
    { value: 'Voice', label: 'Rvm', badgeColor: 'teal.8' },
    { value: 'Email', label: 'Email', badgeColor: 'grape.4' },
];

export const CAMPAIGN_ROUTE_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Sms', label: 'SMS', badgeColor: 'blue.5' },
    { value: 'Email', label: 'Email', badgeColor: 'grape.4' },
];

export const DATA_MANAGER_TYPES = [
    { value: 'Default', label: 'Normal', badgeColor: 'blue' },
];

export const DATA_FILE_TYPES = [
    { value: 'Normal', label: 'Normal', badgeColor: 'gray' },
    { value: 'Leak', label: 'Leak', badgeColor: 'grape.4' },
    { value: 'Suppression', label: 'Suppression', badgeColor: 'red.5' },
    {
        value: 'UserSuppression',
        label: 'User Suppression',
        badgeColor: 'red.6',
    },
    { value: 'Clickers', label: 'Clickers', badgeColor: 'teal.6' },
];

export const DATA_FILE_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // neutral
    { value: 'Uploaded', label: 'Uploaded', badgeColor: 'lime.5' }, // newly added
    { value: 'Processing', label: 'Processing', badgeColor: 'blue.5' }, // working
    { value: 'Importing', label: 'Importing', badgeColor: 'indigo.5' }, // ingesting
    { value: 'Pending', label: 'Pending', badgeColor: 'yellow.4' }, // waiting
    { value: 'Reverify', label: 'Re-verify', badgeColor: 'orange.5' }, // re-checking
    { value: 'Verifying', label: 'Verifying', badgeColor: 'cyan.5' }, // QA pass
    { value: 'Identifying', label: 'Identifying', badgeColor: 'grape.5' }, // entity matching
    { value: 'Finalizing', label: 'Finalizing', badgeColor: 'teal.5' }, // wrap-up
    { value: 'Complete', label: 'Complete', badgeColor: 'green.5' }, // done
    { value: 'Error', label: 'Error', badgeColor: 'red.6' }, // failed
];

export const AGENT_STATUSES = [
    { value: 'None', label: 'Pending', badgeColor: 'gray' },
    { value: 'Connected', label: 'Connected', badgeColor: 'teal.6' },
    { value: 'Disconnected', label: 'Disconnected', badgeColor: 'red' },
    { value: 'Unhealthy', label: 'Unhealthy', badgeColor: 'yellow.6' },
    {
        value: 'ContainerUnhealthy',
        label: 'Container Unhealthy',
        badgeColor: 'orange.8',
    },
];

export const OFFER_CATEGORIES = [
    // ── Health, Wellness & Lifestyle ─────────────────────────────
    {
        value: 'HealthAndWellness',
        label: 'Health & Wellness',
        group: 'Health, Wellness & Lifestyle',
    },
    {
        value: 'BeautyAndSkincare',
        label: 'Beauty & Skincare',
        group: 'Health, Wellness & Lifestyle',
    },
    {
        value: 'WeightLoss',
        label: 'Weight Loss',
        group: 'Health, Wellness & Lifestyle',
    },
    {
        value: 'Fitness',
        label: 'Fitness',
        group: 'Health, Wellness & Lifestyle',
    },
    {
        value: 'PersonalCare',
        label: 'Personal Care',
        group: 'Health, Wellness & Lifestyle',
    },

    // ── Finance & Money ─────────────────────────────────────────
    {
        value: 'PersonalFinance',
        label: 'Personal Finance',
        group: 'Finance & Money',
    },
    { value: 'Banking', label: 'Banking', group: 'Finance & Money' },
    { value: 'CreditCards', label: 'Credit Cards', group: 'Finance & Money' },
    { value: 'Loans', label: 'Loans', group: 'Finance & Money' },
    { value: 'Insurance', label: 'Insurance', group: 'Finance & Money' },
    {
        value: 'InvestmentsAndCrypto',
        label: 'Investments & Crypto',
        group: 'Finance & Money',
    },

    // ── Digital Products & Services ────────────────────────────
    {
        value: 'Software',
        label: 'Software',
        group: 'Digital Products & Services',
    },
    { value: 'SaaS', label: 'SaaS', group: 'Digital Products & Services' },
    {
        value: 'WebHosting',
        label: 'Web Hosting',
        group: 'Digital Products & Services',
    },
    {
        value: 'OnlineEducation',
        label: 'Online Education',
        group: 'Digital Products & Services',
    },
    {
        value: 'StreamingAndVOD',
        label: 'Streaming & VOD',
        group: 'Digital Products & Services',
    },
    {
        value: 'MobileApps',
        label: 'Mobile Apps',
        group: 'Digital Products & Services',
    },
    {
        value: 'AIAndAutomationTools',
        label: 'AI & Automation',
        group: 'Digital Products & Services',
    },

    // ── E-Commerce & Retail ────────────────────────────────────
    {
        value: 'FashionAndApparel',
        label: 'Fashion & Apparel',
        group: 'E-Commerce & Retail',
    },
    {
        value: 'ElectronicsAndGadgets',
        label: 'Electronics & Gadgets',
        group: 'E-Commerce & Retail',
    },
    {
        value: 'HomeAndGarden',
        label: 'Home & Garden',
        group: 'E-Commerce & Retail',
    },
    { value: 'Pets', label: 'Pets', group: 'E-Commerce & Retail' },
    {
        value: 'BabiesAndKids',
        label: 'Babies & Kids',
        group: 'E-Commerce & Retail',
    },
    { value: 'Automotive', label: 'Automotive', group: 'E-Commerce & Retail' },

    // ── Lead Gen & Services ────────────────────────────────────
    {
        value: 'HomeServices',
        label: 'Home Services',
        group: 'Lead Gen & Services',
    },
    {
        value: 'LegalServices',
        label: 'Legal Services',
        group: 'Lead Gen & Services',
    },
    { value: 'RealEstate', label: 'Real Estate', group: 'Lead Gen & Services' },
    {
        value: 'SurveysAndMarketResearch',
        label: 'Surveys & Research',
        group: 'Lead Gen & Services',
    },
    {
        value: 'SweepstakesAndContests',
        label: 'Sweepstakes & Contests',
        group: 'Lead Gen & Services',
    },
    {
        value: 'EmploymentAndCareers',
        label: 'Employment & Careers',
        group: 'Lead Gen & Services',
    },

    // ── Entertainment & Lifestyle ──────────────────────────────
    { value: 'Gaming', label: 'Gaming', group: 'Entertainment & Lifestyle' },
    {
        value: 'MobileGaming',
        label: 'Mobile Gaming',
        group: 'Entertainment & Lifestyle',
    },
    {
        value: 'GamblingAndBetting',
        label: 'Gambling & Betting',
        group: 'Entertainment & Lifestyle',
    },
    { value: 'Dating', label: 'Dating', group: 'Entertainment & Lifestyle' },
    {
        value: 'TravelAndHospitality',
        label: 'Travel & Hospitality',
        group: 'Entertainment & Lifestyle',
    },

    // ── Regulated / Restricted Niches ──────────────────────────
    { value: 'Adult', label: 'Adult', group: 'Regulated & Restricted' },
    {
        value: 'CBDAndHemp',
        label: 'CBD & Hemp',
        group: 'Regulated & Restricted',
    },
    { value: 'Cannabis', label: 'Cannabis', group: 'Regulated & Restricted' },

    // ── General Catch-All ──────────────────────────────────────
    { value: 'Miscellaneous', label: 'Miscellaneous', group: 'Other' },
];

export const DATA_MAP_OPTIONS = [
    /* ── Personal Info ─────────────────────────────────────────── */
    { value: 'phone_number', label: 'Phone Number', group: 'Personal' },
    { value: 'first_name', label: 'First Name', group: 'Personal' },
    { value: 'middle_name', label: 'Middle Name', group: 'Personal' },
    { value: 'last_name', label: 'Last Name', group: 'Personal' },
    { value: 'title', label: 'Title', group: 'Personal' },
    { value: 'email', label: 'Email', group: 'Personal' },
    { value: 'gender', label: 'Gender', group: 'Personal' },
    { value: 'birth_date', label: 'Birth Date', group: 'Personal' },
    { value: 'ssn', label: 'SSN', group: 'Personal' },
    { value: 'record_date', label: 'Record Date', group: 'Personal' },

    /* ── Business Info ─────────────────────────────────────────── */
    { value: 'business_name', label: 'Business Name', group: 'Business' },
    { value: 'business_ein', label: 'Business EIN', group: 'Business' },
    {
        value: 'business_revenue_m',
        label: 'Revenue (Monthly)',
        group: 'Business',
    },
    {
        value: 'business_revenue_y',
        label: 'Revenue (Yearly)',
        group: 'Business',
    },

    /* ── Employment Info ───────────────────────────────────────── */
    {
        value: 'employment_business_name',
        label: 'Employer Name',
        group: 'Employment',
    },
    { value: 'employment_position', label: 'Position', group: 'Employment' },
    { value: 'employment_salary', label: 'Salary', group: 'Employment' },

    /* ── Address Info ──────────────────────────────────────────── */
    { value: 'address_full', label: 'Full Address', group: 'Address' },
    { value: 'address', label: 'Street Address', group: 'Address' },
    { value: 'address_city', label: 'City', group: 'Address' },
    { value: 'address_region', label: 'State / Region', group: 'Address' },
    { value: 'address_country', label: 'Country', group: 'Address' },
    { value: 'address_postal_code', label: 'Postal Code', group: 'Address' },
];

export const CONVERSATION_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // unspecified
    { value: 'NoReply', label: 'No Reply', badgeColor: 'red.6' }, // ignored / bounced
    { value: 'Script', label: 'Script', badgeColor: 'orange.5' }, // automated script
    { value: 'ChatBot', label: 'Chat Bot', badgeColor: 'cyan.5' }, // conversational AI
    { value: 'Manual', label: 'Manual', badgeColor: 'teal.6' }, // human-written
];

export const CONVERSATION_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // neutral
    { value: 'Pending', label: 'Pending', badgeColor: 'yellow.4' }, // awaiting action
    { value: 'Active', label: 'Active', badgeColor: 'teal.5' }, // in progress
    { value: 'Stale', label: 'Stale', badgeColor: 'gray.6' }, // inactive/aged
    { value: 'Stopped', label: 'Stopped', badgeColor: 'grape.5' }, // halted
    { value: 'Complete', label: 'Complete', badgeColor: 'green.5' }, // done
    { value: 'Manual', label: 'Manual', badgeColor: 'blue.5' }, // human handling
    { value: 'Faulted', label: 'Faulted', badgeColor: 'red.6' }, // error
];

export const AI_VOICE_MODELS = [
    { value: 'Default', label: 'Default', badgeColor: 'blue' },
    { value: 'Kokoro', label: 'Kokoro', badgeColor: 'blue' },
];

export const AI_VOICES = [
    { value: 'Default', label: 'Default' },
    { value: 'Kokoro_Alice', label: 'Alice' },
];

export const SHORT_LINK_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // neutral
    { value: 'Provisioning', label: 'Provisioning', badgeColor: 'blue.5' }, // setting up
    { value: 'Propogating', label: 'Propagating', badgeColor: 'cyan.5' }, // in-flight (value keeps enum spelling)
    { value: 'Ready', label: 'Ready', badgeColor: 'teal.6' }, // good to go
    { value: 'Dead', label: 'Dead', badgeColor: 'gray.7' }, // offline / expired
    { value: 'Failed', label: 'Failed', badgeColor: 'red.6' }, // error
    { value: 'Disabled', label: 'Disabled', badgeColor: 'gray.4' }, // intentionally off
];

export const SIM_CARD_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // unspecified
    { value: 'Pending', label: 'Pending', badgeColor: 'yellow.4' }, // awaiting activation
    { value: 'Activated', label: 'Activated', badgeColor: 'teal.6' }, // active/ready
    { value: 'Deactivated', label: 'Deactivated', badgeColor: 'red.6' }, // turned off
    { value: 'Void', label: 'Void', badgeColor: 'gray.7' }, // invalidated
    { value: 'Expired', label: 'Expired', badgeColor: 'orange.5' }, // lapsed
];

export const SIM_CARD_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' }, // unspecified
    { value: 'Physical', label: 'Physical SIM', badgeColor: 'blue.5' }, // hardware card
    { value: 'Esim', label: 'eSIM', badgeColor: 'teal.6' }, // digital profile
];

export const MOBILE_DEVICE_BRANDS = [
    { value: 'Unknown', label: 'Unknown', badgeColor: 'gray.6' }, // neutral
    { value: 'Apple', label: 'Apple', badgeColor: 'indigo.5' }, // premium-ish tone
    { value: 'Android', label: 'Android', badgeColor: 'lime.5' }, // classic green vibe
];

// AgentContainerStatus → Mantine dark-friendly badge colors
export const CONTAINER_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Started', label: 'Started', badgeColor: 'teal.6' },
    { value: 'Stopping', label: 'Stopping', badgeColor: 'orange.5' },
];

// ModemHealthStatus → Mantine dark-friendly badge colors
export const MODEM_HEALTH_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Healthy', label: 'Healthy', badgeColor: 'teal.6' },
    { value: 'Unhealthy', label: 'Unhealthy', badgeColor: 'red.6' },
];

// LteConnectionStatus → Mantine dark-friendly badge colors
export const MODEM_LTE_CONNECTION_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Disconnected', label: 'Disconnected', badgeColor: 'red.6' },
    { value: 'Connected', label: 'Connected', badgeColor: 'teal.6' },
];

// RegistrationStatus → Mantine dark-friendly badge colors
export const MODEM_REGISTRATION_STATUSES = [
    { value: 'NotRegistered', label: 'Not Registered', badgeColor: 'gray.5' },
    { value: 'Registered', label: 'Registered', badgeColor: 'teal.6' },
    { value: 'Searching', label: 'Searching', badgeColor: 'yellow.4' },
    { value: 'Denied', label: 'Denied', badgeColor: 'red.6' },
    { value: 'Unknown', label: 'Unknown', badgeColor: 'gray.6' },
    { value: 'Roaming', label: 'Roaming', badgeColor: 'cyan.5' },
];

// FunctionalityStatus → Mantine dark-friendly badge colors
export const MODEM_FUNCTIONALITY_STATUSES = [
    { value: 'Disabled', label: 'Disabled', badgeColor: 'gray.6' },
    { value: 'Enabled', label: 'Enabled', badgeColor: 'teal.5' },
    { value: 'Flight', label: 'Flight Mode', badgeColor: 'yellow.5' },
    { value: 'Reset', label: 'Reset', badgeColor: 'indigo.5' },
    { value: 'Offline', label: 'Offline', badgeColor: 'gray.7' },
];

export const IMS_CONNECTION_STATUSES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Disconnected', label: 'Disconnected', badgeColor: 'red.6' },
    { value: 'Disposed', label: 'Disposed', badgeColor: 'orange.6' },
    { value: 'Connected', label: 'Connected', badgeColor: 'teal.6' },
];

export const ROUTE_CAPABILITIES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Sms', label: 'SMS', badgeColor: 'teal.6' },
    { value: 'Mms', label: 'MMS', badgeColor: 'teal.6' },
    { value: 'Rvm', label: 'RVM', badgeColor: 'orange.5' },
    { value: 'Voice', label: 'Voice', badgeColor: 'indigo.5' },
    { value: 'Email', label: 'Email', badgeColor: 'blue.5' },
];

// ApnCapabilities → Mantine dark-friendly badge colors
export const APN_CAPABILITIES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Register', label: 'Register', badgeColor: 'indigo.5' },
    { value: 'Internet', label: 'Internet', badgeColor: 'blue.6' },
    { value: 'Ims', label: 'IMS', badgeColor: 'teal.6' },
    { value: 'Mms', label: 'MMS', badgeColor: 'teal.6' },
];

export const VOICE_CALL_TYPES = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Rvm', label: 'RVM (Ringless Voicemail)', badgeColor: 'orange.5' },
    { value: 'VoiceCall', label: 'Voice Call', badgeColor: 'indigo.5' },
];

// VoiceCallResult → Mantine dark-friendly badge colors
export const VOICE_CALL_RESULTS = [
    { value: 'None', label: 'None', badgeColor: 'gray.5' },
    { value: 'Answered', label: 'Answered', badgeColor: 'green.5' },
    { value: 'Voicemail', label: 'Voicemail', badgeColor: 'grape.5' },
    { value: 'VoicemailFull', label: 'Voicemail Full', badgeColor: 'orange.6' },
    { value: 'Busy', label: 'Busy', badgeColor: 'yellow.5' },
    { value: 'Disconnected', label: 'Disconnected', badgeColor: 'gray.7' },
    { value: 'Failed', label: 'Failed', badgeColor: 'red.6' },
    { value: 'Unknown', label: 'Unknown', badgeColor: 'gray.6' },
];

export const MOBILE_CARRIERS = [
    {
        value: 'Att',
        label: 'Att',
        group: 'Att',
    },

    {
        value: 'MobileX',
        label: 'MobileX',
        group: 'Verizon',
    },
    {
        value: 'Twigby',
        label: 'Twigby',
        group: 'Verizon',
    },
    {
        value: 'USMobile',
        label: 'USMobile',
        group: 'Verizon',
    },
    {
        value: 'Verizon',
        label: 'Verizon',
        group: 'Verizon',
    },

    {
        value: 'USCellular',
        label: 'USCellular',
        group: 'USCellular',
    },
];
